import React, { useState, useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AppDownloadModal from '@/components/AppDownloadModal';
import { HelmetProvider } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';

const MainLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [showAppModal, setShowAppModal] = useState(false);

  useEffect(() => {
    const handleOpenAppModal = () => {
      setShowAppModal(true);
    };
    
    window.addEventListener('openAppModal', handleOpenAppModal);
    
    return () => {
      window.removeEventListener('openAppModal', handleOpenAppModal);
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col overflow-x-hidden">
        <Header />
        <main className="flex-1 w-full overflow-x-hidden">{children || <Outlet />}</main>
        <Footer />
        
        {/* App Download Modal - Positioned at top level for proper centering */}
        <AppDownloadModal 
          isOpen={showAppModal} 
          onClose={() => setShowAppModal(false)} 
        />
      </div>
    </HelmetProvider>
  );
};

export default MainLayout; 